import { Form } from "antd";

import { ContactSelect } from "components/selects/contact-select";
import { useOnChange } from "hooks/use-on-change";
import { useSetOpportunityContacts } from "data/use-opportunities";
import { ContactDetailsModal } from "../../../components/modals/contact-details-modal";
import { useModal } from "../../../hooks/use-modal";
import { Modal } from "components/modal";
import { useAccounts } from "../../../data/use-accounts";

export const SetContacts = ({ close, isOpen, opportunity }) => {
  const setOpportunityContacts = useSetOpportunityContacts({
    onSuccess: close,
  });
  const accounts = useAccounts();

  const { modal: contactDetailsModal, open: openContactDetailsModal } =
    useModal(ContactDetailsModal);

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setOpportunityContacts.mutate({
      id: opportunity._id,
      contactIds: values.contactIds,
    });
  };

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        contactIds: opportunity.contacts,
      });
    },
    [isOpen, form, opportunity]
  );

  return (
    <>
      {contactDetailsModal}
      <Modal
        confirmLoading={setOpportunityContacts.isLoading}
        okText="Set Contacts"
        onCancel={close}
        onOk={form.submit}
        title="Contacts"
        open={isOpen}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinish}
        >
          <ContactSelect
            label="Contacts"
            mode="multiple"
            name="contactIds"
            placeholder="Select contacts"
      	    groupBy={opportunity?.accountId ? [{
	      label: `${accounts.labelById(opportunity.accountId, "Account")}`,
	      filter: (contact) => contact.accountId === opportunity.accountId
            }] : undefined}
            extra={
              <div style={{ marginTop: "8px" }}>
                <a
                  onClick={() =>
                    openContactDetailsModal({
                      defaults: { accountId: opportunity.accountId },
                      onCreate: (contact) => {
                        const current = form.getFieldValue("contactIds");

                        form.setFieldValue("contactIds", [
                          ...current,
                          contact._id,
                        ]);
                      },
                    })
                  }
                >
                  Create
                </a>{" "}
                a new contact
              </div>
            }
          />
        </Form>
      </Modal>
    </>
  );
};
